import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-staff',
  templateUrl: './add-staff.component.html',
  styleUrls: ['./add-staff.component.css']
})
export class AddStaffComponent implements OnInit {
  staffData = {
    name: '',
    email: '',
    mobile: '',
    city: '',
    district: '',
    type:'staff'
  };
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }
  submitForm() {
    this.activeModal.close(this.staffData);
  }
  onClose(): void {
    this.activeModal.dismiss('Modal closed'); 
  }
}
